/*
 * This service is for handling the different navigation strategies between full MFP and Budgets
 * There should be no logic included in this file besides conditional navigation between apps
 */

import NavigationService from './navigation.service';
import { createBrowserHistory } from 'history';
import DateUtils from 'src/utils/date';
import { LocalDate } from '@js-joda/core';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import { BUDGET_OVERALL_ID } from 'src/services/budget.service';
import UrlHelper from 'src/utils/url.helper';
import { getSpendsmartLandingPageUrl } from 'src/utils/url.utils';

export const history = createBrowserHistory({ forceRefresh: true });

export const goToLandingPage = (redirect?: boolean): void =>
    window.location.assign(getSpendsmartLandingPageUrl(redirect));

export const goToBudgetPersonalize = (isFullPlanUser: boolean = false, propsHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, BudgetPages.PERSONALIZE);
    else propsHistory.push(BudgetPages.PERSONALIZE);
};
export const goToCurrentBudget = (isFullPlanUser: boolean = false, propsHistory = history, searchParams = ''): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, UrlHelper.getFullPath('budget'));
    else propsHistory.push(`${BudgetPages.HOME}${searchParams}`);
};

export const goToBudgetHistory = (isFullPlanUser = false, propsHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, BudgetPages.HISTORY);
    else propsHistory.push(BudgetPages.HISTORY);
};

export const getCategoryTransactionsUrl = (
    budgetGroupId: string = BUDGET_OVERALL_ID,
    startDate: LocalDate = DateUtils.startDateOfThisMonth(),
    endDate: LocalDate = DateUtils.startDateOfNextMonth()
): string => {
    const searchParams: URLSearchParams = new URLSearchParams();
    if (budgetGroupId !== BUDGET_OVERALL_ID) searchParams.set('group', budgetGroupId);
    searchParams.set('start', startDate.toString());
    searchParams.set('end', endDate.toString());
    return UrlHelper.buildUrl(BudgetPages.TRANSACTIONS, searchParams);
};

export const goToBudgetCategoryTransactions = (
    isFullPlanUser: boolean = false,
    propHistory = history,
    budgetGroupId: string = BUDGET_OVERALL_ID,
    startDate: LocalDate = DateUtils.startDateOfThisMonth(),
    endDate: LocalDate = DateUtils.startDateOfNextMonth()
): void => {
    const path = getCategoryTransactionsUrl(budgetGroupId, startDate, endDate);
    if (isFullPlanUser) void NavigationService.goTo(propHistory, path);
    else propHistory.push(path);
};

export const goToTransactions = (isFullPlanUser: boolean = false, propsHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, BudgetPages.TRANSACTIONS);
    else propsHistory.push(BudgetPages.TRANSACTIONS);
};

export const getTransactionDetailsUrl = (transactionId: number): string =>
    `${BudgetPages.TRANSACTIONS}/${transactionId}`;

export const goToTransactionDetails = (
    transactionId: number,
    isFullPlanUser = false,
    propHistory = history,
    state?: any
): void => {
    const path = getTransactionDetailsUrl(transactionId);
    if (isFullPlanUser) void NavigationService.goTo(history, path);
    else propHistory.push(path, state);
};

export const goToTransactionRules = (isFullPlanUser = false, propHistory = history): void => {
    const path = BudgetPages.TRANSACTIONS_RULES;
    if (isFullPlanUser) void NavigationService.goTo(history, path);
    else propHistory.push(path);
};

export const goToReviewTransactions = (isFullPlanUser: boolean = false, propsHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, BudgetPages.TRANSACTIONS_REVIEW);
    else propsHistory.push(BudgetPages.TRANSACTIONS_REVIEW);
};

export const goToSettings = (isFullPlanUser: boolean = false, propsHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goTo(propsHistory, BudgetPages.SETTINGS);
    else propsHistory.push(BudgetPages.SETTINGS);
};

export const goBack = (isFullPlanUser: boolean = false, propHistory = history): void => {
    if (isFullPlanUser) void NavigationService.goBack(history);
    else propHistory.goBack();
};

export const getCurrentPath = (pathname: string): String => {
    return pathname;
};
